import { ChangeDetectionStrategy, Component, computed, effect, signal } from '@angular/core';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { AppSettingsService } from '../../services/app-settings.service';

@Component({
  selector: 'app-cookie-consent-modal',
  templateUrl: './cookie-consent-modal.component.html',
  styleUrl: './cookie-consent-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CookieConsentModalComponent {
  readonly showPreferences = signal(false);
  readonly analyticsAllowed = signal(false);
  readonly marketingAllowed = signal(false);

  readonly isOpen = computed(() => this.cookieConsentService.isModalOpen());
  readonly isEnabled = computed(() => this.appSettingsService.cookieConsentEnabled());
  readonly hasChoice = computed(() => this.cookieConsentService.hasStoredChoice());

  constructor(
    readonly cookieConsentService: CookieConsentService,
    readonly appSettingsService: AppSettingsService
  ) {
    effect(() => {
      const stored = this.cookieConsentService.preferences();
      if (stored) {
        this.analyticsAllowed.set(stored.analytics);
        this.marketingAllowed.set(stored.marketing);
      }
    }, { allowSignalWrites: true });

    effect(() => {
      if (!this.isOpen()) {
        return;
      }

      if (!this.hasChoice()) {
        this.analyticsAllowed.set(false);
        this.marketingAllowed.set(false);
      }
    }, { allowSignalWrites: true });

    effect(() => {
      if (!this.isEnabled()) {
        this.cookieConsentService.closeModal();
      }
    }, { allowSignalWrites: true });
  }

  acceptAll(): void {
    this.cookieConsentService.acceptAll();
  }

  rejectAll(): void {
    this.cookieConsentService.rejectNonEssential();
  }

  savePreferences(): void {
    this.cookieConsentService.savePreferences({
      analytics: this.analyticsAllowed(),
      marketing: this.marketingAllowed()
    });
  }

  togglePreferences(): void {
    this.showPreferences.update(value => !value);
  }
}
